import { render } from "./CustomPromptDialog.vue?vue&type=template&id=383d0fb5&scoped=true"
import script from "./CustomPromptDialog.vue?vue&type=script&lang=js"
export * from "./CustomPromptDialog.vue?vue&type=script&lang=js"

import "./CustomPromptDialog.vue?vue&type=style&index=0&id=383d0fb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383d0fb5"]])

export default __exports__